<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'base-cascader',
})
</script>
<template>
  <el-cascader
    v-bind="$attrs"
    clearable
    filterable
    placeholder="请选择"
    :options="cascadeData"
    @change="handleChange"
  />
</template>

<script lang="ts" setup name="base-cascader">
  import {
    computed, watch, ref,
  } from 'vue';
  import { useAppStore } from '@/store/app';

  type ModelType = string[] | number[]

  const props = defineProps({
    type: {
      required: true,
      type: String,
      default: '',
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const appStore = useAppStore();
  const dicList = computed(() => appStore.dicList);

  const cascadeData = ref([]);
  watch(
    () => dicList.value,
    (val) => {
      if (val && Object.keys(val).length) {
        const key:any = props.type;
        cascadeData.value = dicList.value[key]?.[0]?.label
          ? JSON.parse(dicList.value[key]?.[0]?.label)
          : [];
      } else {
        cascadeData.value = [];
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );

  const handleChange:Func = (val: ModelType) => {
    emit('update:modelValue', val);
  };
</script>
